import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'gblFilter'
})

export class AppGlobalFilter implements PipeTransform {
    transform(items: any[], searchText?: string, fieldName?: string, childProperty?: string): any[] {

        if(!items) return [];
        if(!searchText) return items;

        searchText = searchText.toLowerCase();
        let res = items;

        if(childProperty){
            items.map(item=>{
                if(item?.[childProperty] && item?.[childProperty]?.length>0){
                    item[childProperty]['childFieldMatched'] = item[childProperty].filter(item => item[fieldName] && item[fieldName].toLowerCase().includes(searchText))?.length||0;
                }
            });

            res = items.filter(item => item[fieldName] && (item[fieldName].toLowerCase().includes(searchText) || item?.[childProperty]?.['childFieldMatched']>0));
        }else{
            res = items.filter(item => item[fieldName] && item[fieldName].toLowerCase().includes(searchText));
        }
        return res;
    }
}

